export enum CategorySetActions {
  Create,
  Set
}
